import { useAiToolkitContext } from '@app/(darkHeader)/ai/_shared/_context/AiToolkitContext';
import { useRouter } from 'next/navigation';
import { type JSX, useCallback } from 'react';

import { ConfirmationModal } from '@videoblocks/design-system';

export const EnterpriseFeatureAccessModal = (): JSX.Element => {
    const { confirmationModal, dispatchConfirmationModal } = useAiToolkitContext();
    const router = useRouter();

    const isOpen = confirmationModal?.type === 'entFeatureAccess' && confirmationModal?.isOpen === true;

    const onClose = useCallback((): void => {
        dispatchConfirmationModal({ type: 'CLOSE_MODAL' });
    }, [dispatchConfirmationModal]);

    const handleContactNow = useCallback((): void => {
        dispatchConfirmationModal({ type: 'CLOSE_MODAL' });
        router.push('/member/support');
    }, [router, dispatchConfirmationModal]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            title="Enterprise Feature Access"
            content="Please contact your Success Team to gain access to this feature."
            confirmLabel="Contact Now"
            cancelLabel="Cancel"
            onConfirm={handleContactNow}
            onCancel={onClose}
        />
    );
};
